/**
 * Import depedencies
 */

import { combineReducers } from 'redux';
import localForage from 'localforage';
import { persistReducer } from 'redux-persist';

/**
 * Import reducers
 */

import { connectRouter } from 'connected-react-router';
import { reducer as notificationsReducer } from 'reapop';

import { localizeReducer } from 'react-localize-redux';
import authenticationReducer from './authentication';
import messageReducer from './message';
import notificationReducer from './notification';
import projectReducer from './project';
import phaseReducer from './phase';
import activityReducer from './activity';
import projectGroupReducer from './project-group';
import groowtorialReducer from './groowtorial';
import processReducer from './process';
import organisationReducer from './organisation';
import favoriteReducer from './favorite';
import categoryReducer from './category';
import scanReducer from './scan';
import skillReducer from './skill';
import sparkReducer from './spark';
import themeReducer from './theme';
import feedbackReducer from './feedback';
import portfolioReducer from './portfolio';
import reflectionReducer from './reflection';
import evidenceReducer from './evidence';
import dreamReducer from './dream';
import peopleReducer from './people';
import assessmentReducer from './assessment';

import trainingReducer from './training';
import trainingAttendanceReducer from './training/attendance';
import trainingAttachmentReducer from './training/attachment';
import trainingSessionReducer from './training/session';
import trainingSessionLessonReducer from './training/session-lesson';
import trainingSubscriptionReducer from './training/subscription';

const authenticationPersistConfig = {
  key: 'authentication',
  storage: localForage,
  whitelist: ['user', 'token'],
};

const projectPersistConfig = {
  key: 'project',
  storage: localForage,
  whitelist: ['entities'],
};

const messagePersistConfig = {
  key: 'message',
  storage: localForage,
  whitelist: ['entities'],
};

const notificationPersistConfig = {
  key: 'notification',
  storage: localForage,
  whitelist: ['entities'],
};

const projectGroupPersistConfig = {
  key: 'projectGroup',
  storage: localForage,
  whitelist: ['entities'],
};

const phasePersistConfig = {
  key: 'phase',
  storage: localForage,
  whitelist: ['entities'],
};

const activityPersistConfig = {
  key: 'activity',
  storage: localForage,
  whitelist: ['entities'],
};

const groowtorialPersistConfig = {
  key: 'groowtorial',
  storage: localForage,
  whitelist: ['entities'],
};

const processPersistConfig = {
  key: 'process',
  storage: localForage,
  whitelist: ['entities'],
};

const organisationPersistConfig = {
  key: 'organisation',
  storage: localForage,
  whitelist: ['entities'],
};

const favoritePersistConfig = {
  key: 'favorite',
  storage: localForage,
  whitelist: ['entities'],
};

const categoryPersistConfig = {
  key: 'category',
  storage: localForage,
  whitelist: ['entities'],
};

const skillPersistConfig = {
  key: 'skill',
  storage: localForage,
  whitelist: ['entities'],
};

const sparkPersistConfig = {
  key: 'spark',
  storage: localForage,
  whitelist: ['entities'],
};

const themePersistConfig = {
  key: 'theme',
  storage: localForage,
  whitelist: ['entities'],
};

const feedbackPersistConfig = {
  key: 'feedback',
  storage: localForage,
  whitelist: ['entities'],
};

const portfolioPersistConfig = {
  key: 'portfolio',
  storage: localForage,
  whitelist: ['entities'],
};

const reflectionPersistConfig = {
  key: 'reflection',
  storage: localForage,
  whitelist: ['entities'],
};

const evidencePersistConfig = {
  key: 'evidence',
  storage: localForage,
  whitelist: ['entities'],
};

const trainingPersistConfig = {
  key: 'training',
  storage: localForage,
  whitelist: ['entities'],
};
const trainingAttachmentPersistConfig = {
  key: 'trainingAttachment',
  storage: localForage,
  whitelist: ['entities'],
};
const trainingAttendancePersistConfig = {
  key: 'trainingAttendance',
  storage: localForage,
  whitelist: ['entities'],
};
const trainingSessionPersistConfig = {
  key: 'trainingSession',
  storage: localForage,
  whitelist: ['entities'],
};
const trainingSessionLessonPersistConfig = {
  key: 'trainingSessionLesson',
  storage: localForage,
  whitelist: ['entities'],
};
const trainingSubscriptionPersistConfig = {
  key: 'trainingSubscription',
  storage: localForage,
  whitelist: ['entities'],
};
const localizePersistConfig = {
  key: 'localize',
  storage: localForage,
};

const dreamPersistConfig = {
  key: 'dream',
  storage: localForage,
  whitelist: ['entities'],
};

const peoplePersistConfig = {
  key: 'people',
  storage: localForage,
  whitelist: ['entities'],
};

const assessmentPersistConfig = {
  key: 'assessment',
  storage: localForage,
  whitelist: ['entities'],
};

export default (history) =>
  combineReducers({
    router: connectRouter(history),
    scan: scanReducer,
    notification: persistReducer(
      notificationPersistConfig,
      notificationReducer
    ),
    notifications: notificationsReducer(),
    authentication: persistReducer(
      authenticationPersistConfig,
      authenticationReducer
    ),
    project: persistReducer(projectPersistConfig, projectReducer),
    projectGroup: persistReducer(
      projectGroupPersistConfig,
      projectGroupReducer
    ),
    phase: persistReducer(phasePersistConfig, phaseReducer),
    activity: persistReducer(activityPersistConfig, activityReducer),
    groowtorial: persistReducer(groowtorialPersistConfig, groowtorialReducer),
    process: persistReducer(processPersistConfig, processReducer),
    organisation: persistReducer(
      organisationPersistConfig,
      organisationReducer
    ),
    assessment: persistReducer(assessmentPersistConfig, assessmentReducer),
    favorite: persistReducer(favoritePersistConfig, favoriteReducer),
    category: persistReducer(categoryPersistConfig, categoryReducer),
    skill: persistReducer(skillPersistConfig, skillReducer),
    spark: persistReducer(sparkPersistConfig, sparkReducer),
    theme: persistReducer(themePersistConfig, themeReducer),
    feedback: persistReducer(feedbackPersistConfig, feedbackReducer),
    portfolio: persistReducer(portfolioPersistConfig, portfolioReducer),
    reflection: persistReducer(reflectionPersistConfig, reflectionReducer),
    evidence: persistReducer(evidencePersistConfig, evidenceReducer),
    training: persistReducer(trainingPersistConfig, trainingReducer),
    message: persistReducer(messagePersistConfig, messageReducer),
    dream: persistReducer(dreamPersistConfig, dreamReducer),
    people: persistReducer(peoplePersistConfig, peopleReducer),
    // trainingAttachment: persistReducer(trainingAttachmentPersistConfig, trainingAttachmentReducer),
    trainingAttendance: persistReducer(
      trainingAttendancePersistConfig,
      trainingAttendanceReducer
    ),
    trainingSession: persistReducer(
      trainingSessionPersistConfig,
      trainingSessionReducer
    ),
    // trainingSessionLesson: persistReducer(trainingSessionLessonPersistConfig, trainingSessionLessonReducer),
    trainingSubscription: persistReducer(
      trainingSubscriptionPersistConfig,
      trainingSubscriptionReducer
    ),
    localize: persistReducer(localizePersistConfig, localizeReducer),
  });
